var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content content--quiz"},[(!_vm.$store.getters.leaderboardLoaded)?_c('OverlayLoader'):_vm._e(),_vm._m(0),_c('MyHeader',{attrs:{"breadcrumbItems":[

      {
        name: _vm.section.name,
        path: ("/" + (_vm.$route.params.companySlug) + "/quizzes")
      },
      {
        name: 'Leaderboards',
        path: ("/" + (_vm.$route.params.companySlug) + "/quizzes/leaderboard")
      },
      {
        name: _vm.quiz.name,
        path: _vm.$route.path
      }
    ]}}),_c('header',{staticClass:"content-header"},[_c('h1',[_vm._v(_vm._s(_vm.quiz.name))])]),_c('div',{staticClass:"container main-content"},[_c('div',{staticClass:"row boxes-row"},_vm._l((_vm.leaderboard),function(box){return _c('div',{key:box.idUser,staticClass:"col-lg-4"},[_c('LeaderboardPlayerBox',{attrs:{"box":box}})],1)}),0),(_vm.onlyPlayer)?_c('div',{staticClass:"quiz-info"},[_vm._v("You are the only player so far!")]):_c('div',{staticClass:"quiz-info"},[_vm._v("Here are the players so far!")])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-img"},[_c('img',{attrs:{"src":require("../../assets/images/hero-quiz.jpg")}})])}]

export { render, staticRenderFns }